export const sleepWithAbort = (ms, signal)=>{
    return new Promise((resolve, reject)=>{
        if (signal.aborted) {
            reject(new DOMException('aborted', 'AbortError'));
            return;
        }
        const onAbort = ()=>{
            clearTimeout(timeoutId);
            reject(new DOMException('aborted', 'AbortError'));
        };
        const timeoutId = setTimeout(()=>{
            signal.removeEventListener('abort', onAbort);
            resolve();
        }, ms);
        signal.addEventListener('abort', onAbort, {
            once: true
        });
    });
};
